import React from "react";

import PropTypes from "prop-types";

import { useDictionary } from "../../../../hooks";
import {
	EMPTY_FIELD_ERROR,
	getFractionError,
	getMaxNumberError,
	getMinNumberError,
	NUMBER_ERROR
} from "./errorMessages";
import styles from "./styles.css";

const FlowableNumberErrorComponent = ({ extraSettings, fractionError, numberError, empty,
	                                      minError, maxError, customValidations = [] }) => {
	const dictionary = useDictionary("common.fieldValidation");

	const { fractionSize, min, max } = extraSettings;

	const customValidationErrors = customValidations
		.filter(({ expression }) => !expression)
		.map(({ errorMsg }, index) =>
			({ message: errorMsg, key: `customValidationError-${index}` }));

	const errors = [
		empty && { message: dictionary.emptyField ?? EMPTY_FIELD_ERROR, key: "emptyError" },
		numberError && { message: dictionary.numberField ?? NUMBER_ERROR, key: "numberError" },
		fractionError && fractionSize !== undefined && { message: getFractionError(fractionSize), key: "fractionError" },
		minError && min !== undefined && { message: getMinNumberError(extraSettings), key: "minError" },
		maxError && max !== undefined && { message: getMaxNumberError(extraSettings), key: "maxError" }
	].filter(Boolean);

	const allErrors = [ ...errors, ...customValidationErrors ];

	if (allErrors.length > 0) {
		return (
			<div>
				{allErrors.map(error => (
					<span key={error.key} className={styles.error}>
						{error.message}
					</span>
				))}
			</div>
		);
	}

	return <></>;
};

FlowableNumberErrorComponent.propTypes = {
	numberError: PropTypes.bool,
	fractionError: PropTypes.bool,
	empty: PropTypes.bool,
	minError: PropTypes.bool,
	maxError: PropTypes.bool,
	customValidations: PropTypes.arrayOf(
		PropTypes.shape({
			expression: PropTypes.string,
			errorMsg: PropTypes.string,
		})
	),
};

FlowableNumberErrorComponent.defaultProps = {
	customValidations: [],
};

export default FlowableNumberErrorComponent;